import "core-js/modules/web.dom-collections.for-each.js";
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, isRef as _isRef, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-5917458c"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "detail"
};

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "客户名称:", -1));

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "订单状态:", -1));

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "备      注:", -1));

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "驳回原因:", -1));

const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "失败原因:", -1));

const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "运费保险费:", -1));

const _hoisted_8 = {
  style: {
    "margin-left": "20px"
  }
};
const _hoisted_9 = {
  style: {
    "margin-left": "20px"
  }
};
const _hoisted_10 = {
  style: {
    "margin-left": "20px"
  }
};

const _hoisted_11 = /*#__PURE__*/_createTextVNode("确认");

import { computed, watch, ref } from 'vue';
import { getOrderDetail } from '@/request';
import { getVexTableProps } from '@/config';
export default {
  name: 'OrderDetailModal',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    data: {
      type: [Object, null],
      default: null
    }
  },
  emits: ['update:modelValue', 'success'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    /** admin/supplier/get_data 订单明细返回的支付方式列表 */

    const payDetailList = computed(() => {
      var _d$payDetailVoList;

      const d = props.data;
      if (!d || typeof d !== 'object') return [];
      const list = (_d$payDetailVoList = d.payDetailVoList) !== null && _d$payDetailVoList !== void 0 ? _d$payDetailVoList : d.pay_detail_vo_list;
      return Array.isArray(list) ? list : [];
    });
    const visible = computed({
      get() {
        return props.modelValue;
      },

      set(val) {
        emit('update:modelValue', val);
      }

    });
    const table = ref();
    watch(() => props.modelValue, () => {
      var _table$value;

      (_table$value = table.value) === null || _table$value === void 0 ? void 0 : _table$value.commitProxy('reload');
    });
    const tableOptions = getVexTableProps({
      columns: [{
        title: '状态',
        field: 'prodStatusText',
        width: '100px'
      }, {
        title: '操作人',
        field: 'cancelBy',
        width: '100px'
      }, {
        title: '药品名称',
        field: 'prodName',
        width: '150px',
        showOverflow: true
      }, {
        title: '生产厂家',
        field: 'manufacture',
        width: '200px',
        showOverflow: true
      }, {
        title: '药品编码',
        field: 'prodNo',
        width: '200px',
        showOverflow: true
      }, {
        title: '药品规格',
        field: 'proSpec',
        width: '150px',
        showOverflow: true
      }, {
        title: '包装单位',
        field: 'packUnit',
        width: '150px',
        showOverflow: true
      }, {
        title: '原始商品数量',
        field: 'o_purchase_num',
        width: '150px',
        showOverflow: true
      }, {
        title: '原始商品单价',
        field: 'o_member_price',
        width: '150px',
        showOverflow: true
      }, {
        title: '优惠金额',
        field: 'allDisMoneyDesc',
        width: '150px',
        showOverflow: true
      }, {
        title: '折后单价',
        field: 'discount_price',
        width: '150px',
        showOverflow: true
      }, {
        title: '折后小计金额',
        field: 'discount',
        width: '150px',
        showOverflow: true
      }, {
        title: '实际出库数量  ',
        field: 'purchase_num',
        width: '150px',
        showOverflow: true
      }, {
        title: '实际出库单价  ',
        field: 'member_price',
        width: '150px',
        showOverflow: true
      }, {
        title: '实际出库金额',
        field: 'relaCount',
        width: '150px',
        showOverflow: true
      }],
      proxyConfig: {
        ajax: {
          query: ({
            page
          }) => new Promise(res => {
            var _props$data;

            getOrderDetail({
              page: page.currentPage,
              rows: page.pageSize,
              orderCode: (_props$data = props.data) === null || _props$data === void 0 ? void 0 : _props$data.order_code_split
            }).then(data => {
              var _data$total;

              const rows = Array.isArray(data === null || data === void 0 ? void 0 : data.rows) ? data.rows : [];
              rows.forEach(item => {
                item.discount = (Number(item.discount_price) * Number(item.o_purchase_num)).toFixed(2);
                item.relaCount = (Number(item.discount_price) * Number(item.purchase_num)).toFixed(2);
              });
              res({
                total: (_data$total = data === null || data === void 0 ? void 0 : data.total) !== null && _data$total !== void 0 ? _data$total : 0,
                result: rows
              });
            }).catch(() => {
              res({
                total: 0,
                result: []
              });
            });
          })
        }
      }
    });
    return (_ctx, _cache) => {
      const _component_el_col = _resolveComponent("el-col");

      const _component_el_row = _resolveComponent("el-row");

      const _component_el_alert = _resolveComponent("el-alert");

      const _component_vxe_grid = _resolveComponent("vxe-grid");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: _unref(visible),
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _isRef(visible) ? visible.value = $event : null),
        title: "订单明细",
        width: "1000px",
        top: "50px"
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[0] || (_cache[0] = $event => visible.value = false)
        }, {
          default: _withCtx(() => [_hoisted_11]),
          _: 1
        })]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [__props.data ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [_createVNode(_component_el_row, null, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 12
          }, {
            default: _withCtx(() => [_hoisted_2, _createTextVNode(" " + _toDisplayString(__props.data.cust_name), 1)]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 12
          }, {
            default: _withCtx(() => [_hoisted_3, _createTextVNode(" " + _toDisplayString(__props.data.order_state), 1)]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_row, null, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 24
          }, {
            default: _withCtx(() => [_hoisted_4, _createTextVNode(" " + _toDisplayString(__props.data.order_note), 1)]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_row, null, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 24
          }, {
            default: _withCtx(() => [_hoisted_5, _createTextVNode(" " + _toDisplayString(__props.data.audit_msg), 1)]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_row, null, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 24
          }, {
            default: _withCtx(() => [_hoisted_6, _createTextVNode(" " + _toDisplayString(__props.data.check_msg), 1)]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_row, null, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 24
          }, {
            default: _withCtx(() => [_hoisted_7, _createTextVNode(" " + _toDisplayString(__props.data.delivery_insurance_amount) + " ", 1), _createElementVNode("span", _hoisted_8, "邮费:" + _toDisplayString(__props.data.postage), 1), _createElementVNode("span", _hoisted_9, "包装费:" + _toDisplayString(__props.data.package_amount), 1), _createElementVNode("span", _hoisted_10, "纸质资质费:" + _toDisplayString(__props.data.qualification_amount), 1)]),
            _: 1
          })]),
          _: 1
        })], 64)) : _createCommentVNode("", true), _createVNode(_component_el_alert, {
          style: {
            "margin": "10px 0"
          },
          title: "订单下传ERP后可能发生冲红、开票员改价等情况，故实际出库商品单价与数量可能发生变更",
          type: "warning"
        }), _createVNode(_component_vxe_grid, _mergeProps({
          ref_key: "table",
          ref: table
        }, _unref(tableOptions)), null, 16)])]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }

};